import { render, staticRenderFns } from "./RecolteTabIcon.vue?vue&type=template&id=32cf7c36"
import script from "./RecolteTabIcon.vue?vue&type=script&lang=js"
export * from "./RecolteTabIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports